import React, { useState, useContext } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axiosInstance from '../axiosConfig';
import { AuthContext } from '../AuthContext';
import './EntityModals.css';

function CompatibilityModal({ show, handleClose, onSubmit }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const { authTokens } = useContext(AuthContext);

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const data = {
            name: name,
            description: description
        };

        axiosInstance.post('/api/create_compatibility/', JSON.stringify(data), {
            headers: {
                'Authorization': `Bearer ${authTokens.access}`,
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.data.success) {
                onSubmit(response.data);
                setName('');
                setDescription('');
                handleClose();
            } else {
                console.error('Ошибка при создании совместимости:', response.data.errors);
            }
        })
        .catch(error => {
            console.error('Ошибка при создании совместимости:', error);
        });
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="entity-modal"
            dialogClassName="entity-modal-dialog entity-modal-dialog--sm"
            contentClassName="entity-modal-content"
        >
            <Modal.Header closeButton>
                <Modal.Title>Добавить совместимость</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} className="entity-form">
                    <Form.Group controlId="formName" className="entity-field">
                        <Form.Label className="entity-label">Название</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formDescription" className="entity-field">
                        <Form.Label className="entity-label">Описание</Form.Label>
                        <Form.Control
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>
                    <div className="entity-actions">
                        <Button className="entity-btn entity-btn-primary" type="submit">
                            Сохранить
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default CompatibilityModal;
